import {PropriedadeAlterada} from "./propriedade-alterada";

export class AlteracoesAudit{
    identificadores: any[];
    propriedades: PropriedadeAlterada[]
}
